<template>
    <div class="bottom-nav">
        <div
            v-for="(item, index) in navList"
            :key="index"
            @click="handleClickNav(item, index)"
            class="bottom-nav-item"
            :class="{ active: navActive === index || item.active}"
        >
            <icon v-if="navActive !== index" :name="item.icon"></icon>
            <icon v-if="navActive === index" :name="item.activeIcon"></icon>
            <div v-if="item.name">{{item.name}}</div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import icon from "@/components/icon/icon"
import router from '@/router/index'
export default {
    name: 'bottomNav',
    components: {
        icon
    },
    props: {
        activeCode: Number
    },
    setup(props) {
        const navActive = ref(0)
        const navList = ref([
            {
                id: 1,
                name: '首页',
                path: '/Mall',
                icon: 'iconhome',
                activeIcon: 'iconhome'
            },
            {
                id: 2,
                name: '收藏',
                path: '/MallLove',
                icon: 'iconloveit',
                activeIcon: 'iconloveit'
            },
            {
                id: 3,
                name: '分类',
                path: '/MallList',
                icon: 'iconleimupinleifenleileibie2',
                activeIcon: 'iconleimupinleifenleileibie2'
            },
            {
                id: 4,
                name: '消息',
                path: '/message',
                icon: 'iconmessage_1',
                activeIcon: 'iconmessage_1'
            },
            {
                id: 5,
                name: '我的',
                path: '/Mine',
                icon: 'iconperson',
                activeIcon: 'iconperson'
            }
        ])

        const handleClickNav = (item, index) => {
            if (item.path) {
                navActive.value = index
                // console.log(item, index)
                router.push({
                    path: item.path
                })
            }
        }
        onMounted(() => {
            navActive.value = props.activeCode
        })

        return {
            navList,
            navActive,
            handleClickNav
        }
    }
}
</script>

<style scoped lang="stylus">
.bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 55px;
    display: grid;
    grid-template-columns: repeat(5,1fr);
    align-items: center;
    text-align: center;
    background: #fff;
    .bottom-nav-item {
        font-size: 12px;
        color: #B2B2B2;
    }
    .active {
        color: #44A73D;
    }
}
</style>
